import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
    extends: Line,
    mixins: [reactiveProp],
    props: {
        chartdata: {
            type: Object,
            default: null
        },
        options: {
            type: Object,
            default: null
        }
    },
    watch: {
        chartLen() {                     
            this.renderChart(this.chartData, this.options)                
        }
    },
    mounted () {
        // this.chartData is created in the mixin.
        // If you want to pass options please create a local options object
        this.renderChart(this.chartData, this.options)
    },
    computed: {
        chartLen(){
            return Object.keys(this.chartData).length != 0 ? this.chartData.datasets[0].data.length: 0
        }
    }
}
